:host {
  background-color: var(--grey-layout-chart-100);
  padding: calc(2 * var(--spacer));
}
